/**
 * FAB ordering tokens for the global #fab-slot in app.vue.
 *
 * Lower = closer to the bottom-right corner. The slot uses flex-row-reverse,
 * so the lowest-order child ends up in the corner and higher-order children
 * stack to its left.
 *
 * Keep this small and stable; FAB stacking is a UI scarcity, not a registry.
 */
export const FAB_ORDER = {
  /** Page-level primary actions (e.g. "Add product"). The corner spot. */
  page: 0,
  /** Persistent global widget — Background Operations Center. */
  boc: 100,
} as const

export type FabOrder = typeof FAB_ORDER[keyof typeof FAB_ORDER]
